module.exports = __webpack_public_path__ + "img/johnston-building-logo.7c7c6b53.jpg";